import { ApiProperty } from "@nestjs/swagger";

export class GrnItemsInfo {
    @ApiProperty()
    grnItemId?: number;

    @ApiProperty()
    grnId?: number;

    @ApiProperty()
    poId?: number;

    @ApiProperty()
    itemCategoryId: number;

    @ApiProperty()
    itemSubCategoryId: number;

    @ApiProperty()
    itemId: number;

    @ApiProperty()
    sizeId: number;

    @ApiProperty()
    stockId: number;

    @ApiProperty()
    poQuantity: number;

    @ApiProperty()
    acceptedQuantity: number;

    @ApiProperty()
    rejectedQuantity: number;

    @ApiProperty()
    receivedQuantity: number;

    @ApiProperty()
    unitPrice: number;

    @ApiProperty()
    discountPercentage: number;

    @ApiProperty()
    discountAmount: number;

    @ApiProperty()
    taxPercentage: number;

    @ApiProperty()
    taxAmount: number;

    @ApiProperty()
    totalAmount: number;
    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()

    createdUser: string;
    @ApiProperty()


    updatedUser?: string;
    @ApiProperty()
    isAsset?: string;
    @ApiProperty()
    itemName?: string;
   



    /**
    * @param grnId
    * @param itemCategoryId
    * @param itemId
    * @param sizeId
    * @param poQuantity
    * @param acceptedQuantity
    * @param rejectedQuantity
    * @param unitPrice
    * @param discountPercentage
    * @param discountAmount
    * @param taxPercentage
    * @param taxAmount
    * @param totalAmount
    * @param createdUser
    * @param updatedUser
    
     */
    constructor(grnId: number,itemCategoryId: number,itemId: number,sizeId: number,poQuantity: number,acceptedQuantity: number,rejectedQuantity: number,unitPrice: number,discountPercentage: number,discountAmount: number,taxPercentage: number,taxAmount: number,totalAmount: number,saleOrderId: number,createdUser: string,updatedUser: string,itemSubCategoryId: number,stockId: number) {
        this.grnId = grnId;
    this.itemCategoryId = itemCategoryId;
    this.itemId = itemId;
    this.sizeId = sizeId;
    this.poQuantity = poQuantity;
    this.acceptedQuantity = acceptedQuantity;
    this.rejectedQuantity = rejectedQuantity;
    this.unitPrice = unitPrice;
    this.discountPercentage = discountPercentage;
    this.discountAmount = discountAmount;
    this.taxPercentage = taxPercentage;
    this.taxAmount = taxAmount;
    this.totalAmount = totalAmount;
    this.createdUser = createdUser;
    this.updatedUser = updatedUser;
    this.saleOrderId = saleOrderId;
    this.itemSubCategoryId = itemSubCategoryId;
    this.stockId = stockId;
    }
}